// @ts-check
// ====== Preferenze utente ======
// Carica/salva le preferenze dell'utente loggato dalla tabella user_preferences.
// Default ragionevoli applicati lato client se mancano chiavi.

const DEFAULT_PREFS = {
  notif_mute: [], // categorie disabilitate, es. ["digest.weekly"]
  scadenze_soglie: [30, 14, 7, 1],
  browser_push: true,
  daily_digest_hour: null // F5: ora 0-23 in cui ricevere il digest, null = off
};

const CATEGORIES = [
  { id: 'cliente.created', label: 'Nuovo cliente creato' },
  { id: 'cliente.updated', label: 'Cliente modificato' },
  { id: 'cliente.trashed', label: 'Cliente messo nel cestino' },
  { id: 'cliente.deleted', label: 'Cliente eliminato definitivamente' },
  { id: 'backup.created', label: 'Backup creato' },
  { id: 'backup.restored', label: 'Ripristino backup' },
  { id: 'utente.deleted', label: 'Utente eliminato' },
  { id: 'scadenza.alert', label: 'Avviso scadenza imminente' },
  { id: 'digest.weekly', label: 'Riepilogo settimanale (lun)' },
  { id: 'digest.daily', label: 'Digest giornaliero (in-app)' }
];

let _cachedPrefs = null;

function getUserPrefs() {
  return _cachedPrefs || { ...DEFAULT_PREFS };
}

async function loadUserPrefs() {
  try {
    const { data: auth } = await sb.auth.getUser();
    const uid = auth?.user?.id;
    if (!uid) {
      _cachedPrefs = { ...DEFAULT_PREFS };
      return _cachedPrefs;
    }
    const { data, error } = await sb
      .from('user_preferences')
      .select('payload')
      .eq('user_id', uid)
      .maybeSingle();
    if (error && error.code !== 'PGRST116') {
      console.warn('Errore caricamento preferenze:', error);
    }
    const payload = (data && data.payload) || {};
    _cachedPrefs = {
      ...DEFAULT_PREFS,
      ...payload,
      notif_mute: Array.isArray(payload.notif_mute) ? payload.notif_mute : DEFAULT_PREFS.notif_mute,
      scadenze_soglie:
        Array.isArray(payload.scadenze_soglie) && payload.scadenze_soglie.length
          ? payload.scadenze_soglie.slice().sort((a, b) => b - a)
          : DEFAULT_PREFS.scadenze_soglie
    };
    return _cachedPrefs;
  } catch (e) {
    console.warn('user_preferences non disponibile:', e);
    _cachedPrefs = { ...DEFAULT_PREFS };
    return _cachedPrefs;
  }
}

async function saveUserPrefs(patch) {
  try {
    const { data: auth } = await sb.auth.getUser();
    const uid = auth?.user?.id;
    if (!uid) {
      toast('Utente non autenticato');
      return;
    }
    const next = { ...getUserPrefs(), ...patch };
    const { error } = await sb
      .from('user_preferences')
      .upsert({ user_id: uid, payload: next }, { onConflict: 'user_id' });
    if (error) throw error;
    _cachedPrefs = next;
    return next;
  } catch (e) {
    console.error(e);
    toast('Errore salvataggio preferenze: ' + (e.message || e));
  }
}

function isNotifMuted(category) {
  return (getUserPrefs().notif_mute || []).includes(category);
}

function getScadenzeSoglie() {
  return getUserPrefs().scadenze_soglie || DEFAULT_PREFS.scadenze_soglie;
}

Object.assign(globalThis, {
  USER_PREF_CATEGORIES: CATEGORIES,
  loadUserPrefs,
  saveUserPrefs,
  getUserPrefs,
  isNotifMuted,
  getScadenzeSoglie
});
export {};
